module.exports = __webpack_public_path__ + "img/icone_fluxo_reverso.a1743d4b.png";